import { useState } from 'react'
import { httpsCallable } from 'firebase/functions'
import { functions } from '../lib/firebase'
import { signOutFromAll } from '../lib/auth'
import { log } from '../lib/logger'

const callDeleteAccount = httpsCallable<void, { success: boolean }>(functions, 'deleteAccount')

// Calls the deleteAccount Cloud Function, then clears the local session. The
// Auth record is gone server-side by the time this resolves, so signing out
// just tidies up client + native state.
export function useDeleteAccount() {
  const [deleting, setDeleting] = useState(false)

  async function deleteAccount(): Promise<void> {
    setDeleting(true)
    log('account', 'delete start')
    try {
      await callDeleteAccount()
      log('account', 'delete ok')
      await signOutFromAll()
    } catch (err) {
      log('account', 'delete failed', { code: (err as { code?: string })?.code ?? String(err) })
      throw err
    } finally {
      setDeleting(false)
    }
  }

  return { deleteAccount, deleting }
}
